import { VeriDate } from "@services/veriDate.service";

export function veriDate(veriDate: VeriDate) {

    return (input: string, outputFormat: string) => {

        return veriDate.formatDate(input, outputFormat);
    }
}
